import React from 'react';
import SvgIcon from '../SvgIcon';
export default function factorySvgIcon(IconComp) {
    const Component = (props, ref) => {
        return React.createElement(SvgIcon, Object.assign({ IconComp: IconComp }, props, { forwardedRef: ref }));
    };
    return React.memo(React.forwardRef(Component));
}
//# sourceMappingURL=factorySvgIcon.js.map